import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import * as Icons from "@nxt-costco-com/forge-icons";
import { Text } from "../../../DataDisplay/Text/index.js";
import { SelectorRadioContentStyles, RadioMarkdownStyles } from "./styles.js";
import { MarkdownRenderer } from "../../../Media/MarkdownRenderer/index.js";
const SelectorRadioContent = (props) => {
  const styles = SelectorRadioContentStyles();
  const {
    title,
    iconName,
    subtitle,
    body,
    bodyStyles,
    uniqueId,
    isMarkdown = false,
    isTitleBold = false
  } = props;
  const Icon = iconName && Icons[iconName];
  return /* @__PURE__ */ jsxs(Box, { sx: styles.box, children: [
    (title || Icon) && /* @__PURE__ */ jsxs(Box, { sx: styles.titleWrapper, children: [
      Icon && /* @__PURE__ */ jsx(Icon, { sx: styles.icon }),
      title && /* @__PURE__ */ jsx(
        Text,
        {
          variant: "t5",
          bold: isTitleBold,
          uniqueId: `${uniqueId}_title`,
          children: title
        }
      )
    ] }),
    subtitle && /* @__PURE__ */ jsx(Text, { variant: "t6", uniqueId: `${uniqueId}_subtitle`, children: subtitle }),
    body && !isMarkdown && /* @__PURE__ */ jsx(
      Text,
      {
        variant: "t6",
        uniqueId: `${uniqueId}_body`,
        sx: bodyStyles || styles.body,
        children: body
      }
    ),
    typeof body == "string" && isMarkdown && /* @__PURE__ */ jsx(
      MarkdownRenderer,
      {
        markdown: body,
        styles: RadioMarkdownStyles
      }
    )
  ] });
};
export {
  SelectorRadioContent
};
